import { useEffect, useState } from "react";
import { userIdentity, adminAuth, agencyAuth } from "./identity";

// Singletons are stable for the lifetime of the app, so the subscribe call
// only ever needs to run once.

export const useUserPhone = () => {
  const [v, setV] = useState(userIdentity.getPhone());
  useEffect(() => userIdentity.subscribe(setV), []);
  return [v, userIdentity.setPhone.bind(userIdentity)];
};

// Boolean session flag — see /app/frontend/src/lib/identity.js for the
// httpOnly cookie story. Returns [isLoggedIn, markLoggedIn, clear].
export const useAdminAuth = () => {
  const [v, setV] = useState(adminAuth.isLoggedIn());
  useEffect(() => adminAuth.subscribe(setV), []);
  return [v, adminAuth.markLoggedIn.bind(adminAuth), adminAuth.clear.bind(adminAuth)];
};

export const useAgencyAuth = () => {
  const [v, setV] = useState(agencyAuth.get());
  useEffect(() => agencyAuth.subscribe(setV), []);
  return [v, agencyAuth.set.bind(agencyAuth)];
};
